if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
    const wishlistCount = document.querySelector('.site-header__wishlist__count');
    if(wishlistCount){
      if(products.length > 0){
        wishlistCount.classList.remove('is-hidden');
      } else {
        wishlistCount.classList.add('is-hidden');
      }
      wishlistCount.innerHTML = products.length;
    }
	});
}

const wishtlistButton = document.querySelector('.wishlist-btn');
if(wishtlistButton){
  wishtlistButton.addEventListener('click', function(){
    setTimeout(function(){
      window.SwymCallbacks.push(swymRenderWishlist);
    }, 500);
  });
}
